module.exports = __webpack_public_path__ + "img/price-banner-md.12979812.jpg";